import React from "react";

const Footer = ({ color }) => {
  const year = new Date().getFullYear(); 
  return (
    <>
      <div className="uk-position-relative">
        <div className="footerwrp" style={{ backgroundColor: color }}>
          <div uk-grid="" className="uk-grid">
            <div className="uk-width-1-2">
              <div className="brandName">
                <span>© {year} BYD MEGA MOTOR. All rights reserved.</span>
              </div>
            </div>
            <div className="uk-width-1-2">
              <div className="brandName uk-text-right">

                <a href="https://www.convexinteractive.com/"><span>Powered by  Convex Interactive</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
